import { Suspense } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CompareDrawer from "@/components/CompareDrawer";
import LaunchGate from "@/components/LaunchGate";
import PageFallback from "@/components/PageFallback";

/** Private-shell wrapper for existing marketplace pages.
 *  The Vanturis frame (Navbar / Footer / background) renders IMMEDIATELY;
 *  only the protected content region is gated by LaunchGate. This prevents
 *  the blank / generic full-page "Loading…" flash on hard refresh or direct
 *  address loads. Protected content is still withheld until authorization.
 *
 *  P1B: a Suspense boundary wraps ONLY the content region so lazily-loaded
 *  route chunks show a local content fallback — the Navbar/Footer never
 *  unmount, so navigation stays immediate and premium. */
export default function PrivateShell({ requireAuth = false, children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-[70vh]">
        <LaunchGate requireAuth={requireAuth}>
          <Suspense fallback={<PageFallback />}>{children}</Suspense>
        </LaunchGate>
      </main>
      <CompareDrawer />
      <Footer />
    </>
  );
}
